/**
 * ****************************************************************************
 * @description     :   Store data and common process for header
 * @created at      :   2024/10/23
 * @created by      :   ANS902 - quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

const dataPassWord = {
    password_old: '',
    password_new: '',
    password_confirm: ''
};

const buildDefaultTimeCardState = () => ({
    timerHistory: {
        timer_history: []
    },
    currentStatusName: '',
    statusName: '出勤',
    statusDiv: '0',
    hideActionButton: false,
    timeCardMeta: {
        nextAction: 'IN',
        attendanceId: 0,
        workDate: '',
        serverDateTime: '',
        workflowContext: null,
        schedule: {}
    },
    isLoadingTimeCard: false
});

export default {
    namespaced: true,
    state: {
        data: { ...dataPassWord },
        ...buildDefaultTimeCardState()
    },
    mutations: {
        setData(state, data) {
            state.data = data ?? [];
        },
        setStatus(state, payload) {
            state.statusDiv = payload.div ?? state.statusDiv;
            state.currentStatusName = payload.currentName ?? state.currentStatusName;
            state.statusName = payload.name ?? state.statusName;
            state.hideActionButton = payload.hideActionButton ?? state.hideActionButton;
        },
        setTimeCardLoading(state, isLoading) {
            state.isLoadingTimeCard = !!isLoading;
        },
        setTimeCardState(state, payload = {}) {
            const historyRows = Array.isArray(payload.history)
                ? payload.history
                : Array.isArray(payload.timer_history)
                ? payload.timer_history
                : Array.isArray(payload.timerHistory?.timer_history)
                ? payload.timerHistory.timer_history
                : Array.isArray(payload.timerHistory)
                ? payload.timerHistory
                : [];
            state.timerHistory = {
                timer_history: historyRows
            };
            state.currentStatusName = payload.currentStatusName ?? '';
            state.statusName = payload.statusName ?? '出勤';
            state.statusDiv = payload.statusDiv ?? '0';
            state.hideActionButton = !!payload.hideActionButton;
            state.timeCardMeta = {
                nextAction: payload.nextAction ?? 'IN',
                attendanceId: payload.attendanceId ?? 0,
                workDate: payload.workDate ?? '',
                serverDateTime: payload.serverDateTime ?? '',
                workflowContext: payload.workflowContext ?? null,
                schedule: payload.schedule ?? {}
            };
        },
        resetTimeCardState(state) {
            const nextState = buildDefaultTimeCardState();
            state.timerHistory = nextState.timerHistory;
            state.currentStatusName = nextState.currentStatusName;
            state.statusName = nextState.statusName;
            state.statusDiv = nextState.statusDiv;
            state.hideActionButton = nextState.hideActionButton;
            state.timeCardMeta = nextState.timeCardMeta;
            state.isLoadingTimeCard = nextState.isLoadingTimeCard;
        }
    },
    actions: {
        changePassWordMNG(context, input) {
            try {
                repository.changePassWordMNG(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message[0]);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        changePassWordCUS(context, input) {
            try {
                repository.changePassWordCUS(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message[0]);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        async loadTimeCard({ commit }, params = {}) {
            commit('resetTimeCardState');
            commit('setTimeCardLoading', true);
            try {
                const res = await repository.getTimeCardStatus(params);
                const responseData = res?.data ?? {};
                const timeCard = responseData?.Data?.timeCard ?? null;

                if (responseData.Code === 200 && timeCard) {
                    commit('setTimeCardState', timeCard);
                }

                return {
                    code: responseData.Code,
                    message: responseData.Message ?? '',
                    timeCard
                };
            } catch (e) {
                return {
                    code: 423,
                    message: e.message ?? 'タイムカードの取得に失敗しました。',
                    timeCard: null
                };
            } finally {
                commit('setTimeCardLoading', false);
            }
        },
        async executeTimeCardAction({ commit }, body = {}) {
            try {
                const res = await repository.executeTimeCardAction(body);
                const responseData = res?.data ?? {};
                const result = responseData?.Data ?? {};

                if (result?.timeCard) {
                    commit('setTimeCardState', result.timeCard);
                }

                return {
                    code: responseData.Code,
                    message: responseData.Message ?? result.message ?? '',
                    ...result
                };
            } catch (e) {
                return {
                    code: 423,
                    completed: false,
                    requiresWorkflow: false,
                    message: e.message ?? 'タイムカード処理に失敗しました。'
                };
            }
        }
    }
};
